import React from 'react'
import { Link, useLocation } from 'react-router-dom';

const Sidebar = () => {

  const menuItems = [
    { id: "dashboard", label: "Dashboard", icon: "📊", route: "/supplement"},
    { id: "orders", label: "Order Management", icon: "📦", route: "/supplement/orders"},
    { id: "inventory", label: "Inventory Management", icon: "💊", route: "/supplement/inventory"},
    { id: "gallery", label: "Image Gallery", icon: "🖼️", route: "/supplement/gallery"},
    { id: "notifications", label: "Notifications", icon: "🔔", route: "/supplement/notifications"},
  ];

  const location = useLocation();

  return (
    <div className="w-68 bg-slate-900 h-screen flex flex-col border-r border-slate-800 z-20">
      <div className="p-6">
        <h1 className="text-2xl font-bold text-emerald-500 flex items-center gap-2">
          <span>🌿</span> SuppleTrack
        </h1>
        <p className="text-slate-400 text-xs mt-1">Supplement Admin Portal</p>
      </div>

      <nav className="flex-1 px-4 mt-4 overflow-y-auto scrollbar-hide">
        {menuItems.map((item) => (
          <Link to={item.route}
            key={item.id}
            // onClick={() => setActiveTab(item.id)}
            className={`w-full text-left px-4 py-3 rounded-xl mb-2 flex items-center gap-3 transition-all duration-200 ${
              location.pathname === item.route
                ? "bg-emerald-600 text-white shadow-lg shadow-emerald-900/20"
                : "text-slate-400 hover:bg-slate-800 hover:text-white"
            }`}
          >
            <span className="text-xl">{item.icon}</span>
            <span className="font-medium">{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="p-4 border-t border-slate-800 mt-auto space-y-4">
        <div className="flex items-center gap-3 bg-slate-800/50 p-3 rounded-xl">
          <div className="w-8 h-8 rounded-full bg-emerald-500 flex items-center justify-center text-white font-bold">
            A
          </div>
          <div>
            <p className="text-sm font-medium text-white">Admin User</p>
            <p className="text-xs  text-emerald-400">
              Store Manager
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar